<template>
    <el-config-provider :button="buttonConfig" :locale="zhCn">
        <router-view />
    </el-config-provider>
</template>

<script setup lang="ts">
import { ElConfigProvider } from "element-plus";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import Tenant from "@/function/tenant";
const buttonConfig = { autoInsertSpace: false };
zhCn.el.pagination = Object.assign(zhCn.el.pagination, { goto: "转到" });

onMounted(async () => {
    await Tenant.getInstance().init();
    await nextTick();
    // 更新页面标题
    document.title = Tenant.getInstance().theme.systemName || import.meta.env.VITE_GLOB_APP_TITLE;
});
</script>
